import TopPageLink from './TopPageLink'

export default TopPageLink
